export class CompanyValue {
    id : number;
    imgSrc : string;
    imgSrcBlue : string;
    title : string;
    text : string;

    constructor(id:number, imgSrc:string, imgSrcBlue:string, title:string, text:string) {
        this.id = id;
        this.imgSrc = imgSrc;
        this.imgSrcBlue = imgSrcBlue;
        this.title = title;
        this.text = text;
    }
}